module.exports = __webpack_public_path__ + "img/taschenrechner(1).f5e12a49.png";